import { z } from "zod";

export const WorkflowVersionValues = [
  "btp-1.0",
  "btp-1.1",
  "btp-1.2",
  "met-1.0",
  "colp-1.0",
] as const;

export type WorkflowVersion = (typeof WorkflowVersionValues)[number];
export const WorkflowVersionSchema = z.enum({
  BTP_1_0: "btp-1.0",
  BTP_1_1: "btp-1.1",
  BTP_1_2: "btp-1.2",
  MET_1_0: "met-1.0",
  COLP_1_0: "colp-1.0",
} satisfies Record<string, WorkflowVersion>);
